import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    align-items: center;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    display: flex;
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    transition: background 0.3s ease, color 0.3s ease;
  }

  ::selection {
    background: ${({ theme }) => theme.imageHighlight};
    color: ${({ theme }) => theme.body};
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.body};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.headerColor};
    border-radius: 8px;
    border: 2px solid ${({ theme }) => theme.body};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.imageHighlight};
  }`;
